import React from 'react';

const Box = ({children}) => {
  return (
    <div className="w-full h-auto overflow-auto border p-4">
      <div className={`grid gap-1 justify-start items-end`}>
        {children}
      </div>
    </div>
  );
};

export default Box;